












import { ImageContent, ImageSize } from '@/resource/question/question.type';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SubjectiveImage extends Vue {
  @Prop({ required: true })
  content!: ImageContent;

  get images() {
    return this.content.content;
  }

  getImageSize(imageSize: ImageSize) {
    let size = '';

    switch (imageSize) {
      case ImageSize.Full:
        size = 'w-full';
        break;
      case ImageSize.Half:
        size = 'w-1/2';
        break;
      case ImageSize.Third:
        size = 'w-1/3';
        break;
    }

    return size;
  }
}
